import React from 'react';
import JournalLanding from './JournalLanding';
import JournalForm from './JournalForm';

const Journal = () => {
  return (
    <div>
      <JournalLanding />
      <JournalForm />
    </div>
  );
};

export default Journal;